export default __webpack_public_path__ + "static/media/fig-01-terminology.0b673d0b.png";